import { GET_EXPENSE_REQUEST, GET_EXPENSE_SUCCESS, GET_EXPENSE_FAIL,
    CREATE_EXPENSE_REQUEST, CREATE_EXPENSE_SUCCESS, CREATE_EXPENSE_FAIL,
    UPDATE_EXPENSE_REQUEST, UPDATE_EXPENSE_SUCCESS, UPDATE_EXPENSE_FAIL,
    DELETE_EXPENSE_REQUEST, DELETE_EXPENSE_SUCCESS, DELETE_EXPENSE_FAIL  } from "../types/expenseMasterTypes";

function deleteExpenseReducer( state = { deleteExpense: {}}, action) {
    switch (action.type) {
        case DELETE_EXPENSE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_EXPENSE_SUCCESS:
            return {
                ...state,
                deleteExpense: action.payload,
                isLoading: false
            }       
        case DELETE_EXPENSE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateExpenseReducer( state = { updateExpense: {}}, action) {
    switch (action.type) {
        case UPDATE_EXPENSE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_EXPENSE_SUCCESS:
            return {
                ...state,
                updateExpense: action.payload,
                isLoading: false
            }       
        case UPDATE_EXPENSE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createExpenseReducer( state = { createExpense: {}}, action) {
    switch (action.type) {
        case CREATE_EXPENSE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_EXPENSE_SUCCESS:
            return {
                ...state,
                createExpense: action.payload,
                isLoading: false
            }       
        case CREATE_EXPENSE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getExpenseReducer( state = { expense: []}, action) {
    switch (action.type) {
        case GET_EXPENSE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_EXPENSE_SUCCESS:
            return {
                ...state,
                expense: action.payload,
                isLoading: false
            }       
        case GET_EXPENSE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { getExpenseReducer, createExpenseReducer, updateExpenseReducer, deleteExpenseReducer }